import main from './route.svg';
import active from './route-filled.svg';
import disabled from './route-gestalt.svg';

export default { main, active, disabled };
